import { NgModule } from '@angular/core';
import { CurrencyDisplayPipe } from './currency-display.pipe';

/**
 * Shared module that owns the CurrencyDisplayPipe declaration so it can be reused by
 * lazy-loaded feature modules (e.g. signup-vN) instead of only app.module. A pipe class
 * may only be declared once across the app, so any module needing it imports this.
 */
@NgModule({
  declarations: [CurrencyDisplayPipe],
  exports: [CurrencyDisplayPipe]
})
export class CurrencyDisplayPipeModule {}
